import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchPosts, fetchCategories, fetchTags } from "../lib/api";

const ContentContext = createContext({
  posts: [],
  categories: [],
  tags: [],
  loading: true,
  error: null,
  ready: false,
});

export function ContentProvider({ children }) {
  const [state, setState] = useState({
    posts: [],
    categories: [],
    tags: [],
    loading: true,
    error: null,
    ready: false,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [posts, categories, tags] = await Promise.all([
          fetchPosts({ limit: 500 }),
          fetchCategories(),
          fetchTags(),
        ]);
        if (cancelled) return;
        setState({ posts, categories, tags, loading: false, error: null, ready: true });
      } catch (e) {
        if (cancelled) return;
        setState((s) => ({ ...s, loading: false, error: e?.message || "Failed to load content", ready: false }));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // Derived helpers
  const value = {
    ...state,
    getPost: (slug) => state.posts.find((p) => p.slug === slug),
    getFeatured: () => state.posts.filter((p) => p.featured),
    postsByCategory: (slug) => state.posts.filter((p) => p.categories?.includes(slug)),
    postsByTag: (slug) => state.posts.filter((p) => p.tags?.includes(slug)),
    getCategory: (slug) => state.categories.find((c) => c.slug === slug),
    getTag: (slug) => state.tags.find((t) => t.slug === slug),
  };

  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
